import { useEffect, useState } from "react";
import { Form } from "react-final-form";
import { useTheme } from "@emotion/react";
import SwipeableViews from "react-swipeable-views";
import ComplaintsFormStepOne from "./ComplaintsFormSteps/ComplaintsFormStepOne";
import { onSubmit, onValidate } from "./ComplaintsFormSubmit";
import ComplaintsFormStepTwo from "./ComplaintsFormSteps/ComplaintsFormStepTwo";
import moment from "moment";

const ComplaintsForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    if (update && _initialValues) {
      const device = _initialValues.device || {};
      const representative = _initialValues.representative || {};
      const contractor = _initialValues.contractor || {};

      setInitialValues({
        ..._initialValues,
        complaintTitle: _initialValues.complaintTitle || "",
        contractor: contractor.uuid
          ? {
              uuid: contractor.uuid,
              value: contractor.uuid,
              name: contractor.name,
              ...contractor,
            }
          : null,
        receivedDate: _initialValues.receivedDate || null,
        plannedClosingDate: _initialValues.plannedClosingDate || null,

        // Przedmiot reklamacji
        device: device.uuid
          ? {
              uuid: device.uuid,
              value: device.uuid,
              serialNumber: device.serialNumber,
              ...device,
            }
          : null,
        deviceInvoice: device.deviceInvoice || "",
        deviceDateOfBuy: device.deviceDateOfBuy || null,
        deviceWarrantyTo: device.deviceWarrantyTo || null,

        // Osoba do kontaktu
        representative: representative.uuid
          ? {
              value: representative.uuid,
              uuid: representative.uuid,
              name: `${representative.name || ""} ${
                representative.lastname || ""
              }`.trim(),
              ...representative,
            }
          : null,
        representativePhone: representative.phoneNumber || "",
        representativeEmail: representative.email || "",
        // Step 2
        complaintReason: _initialValues.complaintReason || "",
        customerExpectations: _initialValues.customerExpectations?.uuid
          ? { value: _initialValues.customerExpectations.uuid }
          : null,
        complaintRemarks: _initialValues.complaintRemarks || "",
        additionalCustomerInformation:
          _initialValues.additionalCustomerInformation || "",
        requestedAdditionalServices:
          _initialValues.requestedAdditionalServices || "",
        deliveredWithDevice: _initialValues.deliveredWithDevice || "",
        diagnosticCost: _initialValues.diagnosticCost || "",
        guarantor: _initialValues.guarantor?.uuid
          ? { value: _initialValues.guarantor.uuid }
          : null,
      });
      return;
    }

    setInitialValues({
      receivedDate: moment(),
    });
  }, [update, _initialValues]);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, props)}
      validate={(val) => onValidate(val, props)}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="ComplaintsForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <ComplaintsFormStepOne {...formProps} {...props} />
              <ComplaintsFormStepTwo {...formProps} {...props} />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default ComplaintsForm;
